/**
 * Public Booking Page
 * Standalone page for the booking widget, can be embedded in iframe
 */

import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BookingWidget } from '../../components/public-booking';

export function BookingPage() {
  const [searchParams] = useSearchParams();

  // Get configuration from URL params
  const language = (searchParams.get('lang') as 'es' | 'en') || 'es';
  const source = (searchParams.get('source') as 'public_widget' | 'marketing_link') || 'public_widget';
  const campaignId = searchParams.get('campaign') || undefined;

  // Handle iframe resizing
  const [, setHeight] = useState(0);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const height = entry.contentRect.height;
        setHeight(height);
        // Send height to parent for iframe resizing
        if (window.parent !== window) {
          window.parent.postMessage({ type: 'LEAL_BOOKING_RESIZE', height }, '*');
        }
      }
    });

    const container = document.getElementById('booking-container');
    if (container) {
      resizeObserver.observe(container);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div id="booking-container" className="min-h-screen bg-gray-50 py-8 px-4">
      <BookingWidget
        language={language}
        source={source}
        campaignId={campaignId}
      />
    </div>
  );
}

export default BookingPage;
